<template>
  <div class="app-container">
    <div>
      <el-table
        ref="elTable"
        :data="tableData"
        border
        :height="tableHeight"
        @header-dragend="headerWidthChange"
      >
        <el-table-column :label="$t('operationCenter.ind')" width="60px" align="center">
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in currentColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :align="item.fixed"
          :width="item.width"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, ind) in getCurrentColumns"
          :key="ind + 100"
          :prop="item.prop"
          :label="item.label"
          :align="item.fixed"
          :width="item.width"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="getExamineTableData"
          @size-change="getExamineTableData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { apiPayableSiteExpenseGetPage } from '@/api/finance/receivables';
import { getCostSiteExpensePage } from '@/api/finance/costManagement';
import { cloneDeep } from 'lodash-es';

export default {
  name: 'BatchNumberDetail',
  props: {
    batchNumberData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    type: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          payableNumber: '' // 收款单号
        }
      },
      total: 0,
      tableData: [],
      currentColumns: [],
      getCurrentColumns: [],
      // selectData: [],
      tableHeight: 0
      // totalFee: 0
    };
  },
  computed: {
    columnList() {
      return [
        {
          label: this.$i18n.t('basicData.all'), // '全部',
          prop: '',
          children: [
            // 业务单号
            { prop: 'waybillNumber', label: this.$i18n.t('receivablePayable.TicketNumber'), width: 160, fixed: 'left', highlight: false, disabled: true },
            // 应付主体
            { prop: 'providerName', label: this.$i18n.t('basicData.PayablePrincipal'), width: 120, fixed: 'left', highlight: false, disabled: true },
            // 应付网点
            { prop: 'siteName', label: this.$i18n.t('basicData.PayableOutlets'), width: 120, fixed: 'left', highlight: false, disabled: true },
            // 揽收人
            { prop: 'collectorsName', label: this.$i18n.t('collectionCenter.LanShouPeople'), width: 160, fixed: 'left', highlight: false, disabled: true },
            // 派送人
            { prop: 'dispatcherName', label: this.$i18n.t('collectionCenter.deliverer'), width: 120, fixed: 'left', highlight: true, disabled: true },
            // 计费重量
            { prop: 'chargeWeight', label: this.$i18n.t('receivablePayable.BillableWeight'), width: 120, fixed: 'left', highlight: true, disabled: true },
            // 应付费用
            { prop: 'totalFee', label: this.$i18n.t('basicData.FeesPayable'), width: 120, fixed: 'left', highlight: true, disabled: true },
            // 备注
            { prop: 'remark', label: this.$i18n.t('basicData.remark'), width: 160, fixed: 'left', highlight: false, disabled: true }
          ]
        }
      ];
    }
  },
  created() {
    this.tableHeight = document.body.clientHeight - 124;
    if (this.type === 5) {
      this.currentColumns = this.columnList[0].children.filter(item => !['collectorsName', 'dispatcherName'].includes(item.prop));
    } else {
      this.currentColumns = this.columnList[0].children;
    }
    this.queryForm.params.payableNumber = this.batchNumberData.payableNumber;
    this.getExamineTableData();
  },
  mounted() {
    // 页面加载的时候设置table的高度
    this.tableHeight = document.body.clientHeight - 124;
    // 页面大小该变的时候（缩放页面）设置table的高度（可加可不加）
    window.onresize = () => {
      this.tableHeight = document.body.clientHeight - 124;
    };
  },
  methods: {
    // 表头宽度变化
    headerWidthChange() {
      this.$nextTick(() => {
        this.$refs.elTable.doLayout();
      });
    },
    // 获取列表
    getExamineTableData() {
      const param = cloneDeep(this.queryForm);
      this.getCurrentColumns = [];
      const fn = this.type === 5 ? getCostSiteExpensePage : apiPayableSiteExpenseGetPage;
      // 获取列表数据
      fn(param).then(resp => {
        if (resp.code === 200) {
          this.tableData = resp.data;
          this.total = resp.total;
          if (resp.data.length > 0) {
            this.getCurrentColumns = [];
            resp.columns.map(item => {
              const obj = {
                prop: item.prop,
                label: item.label.split('_')[0],
                width: 200,
                fixed: 'left',
                highlight: false
              };
              this.getCurrentColumns.push(obj);
              this.$nextTick(() => {
                this.$refs.elTable.doLayout();
                // this.tableData.map(list => {
                //   const matchedIndex = this.selectData.findIndex(itemList => itemList.id === list.id);
                //   this.$refs.elTable.toggleRowSelection(list, matchedIndex !== -1);
                // });
              });
            });
          }
        }
      }).catch(err => {
        console.error(err);
      });
    }
  }
};
</script>

<style scoped>

</style>
